import React, { Component } from 'react';
import MegaMenu from './MegaMenu';

class Navbar extends Component {
    render() {
        return (
            <>
                <MegaMenu />
            </>
        );
    }
}

export default Navbar;
